import { render, staticRenderFns } from "./BuscarYRegistrarAbonado.vue?vue&type=template&id=df51228c"
import script from "./BuscarYRegistrarAbonado.vue?vue&type=script&setup=true&lang=js"
export * from "./BuscarYRegistrarAbonado.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports